<script lang="ts">
	// Skeleton placeholder primitive with a small visual vocabulary selected via
	// `tone`: 'neutral' (gray shimmer, default), 'accent' (soft brand-tinted
	// shimmer for hero/button silhouettes), 'surface' (white card with a soft
	// border, static — no shimmer). Reserves a real footprint via height/width
	// CSS variables so the layout it composes stays dimension-stable (low CLS)
	// when the variant swaps in. `heightSm` optionally swaps the height at
	// >=640px (used by the footer band contract). Respects prefers-reduced-motion
	// (static fill, no shimmer). No content, no focusable elements.
	export type SkeletonTone = 'neutral' | 'accent' | 'surface';
	export let tone: SkeletonTone = 'neutral';
	export let height: string = '1rem';
	export let width: string = '100%';
	export let radius: string = '0.5rem';
	export let heightSm: string | null = null;
	export let className: string = '';
	$: shimmer = tone !== 'surface';
</script>

<div
	class="skeleton-block {className}"
	class:shimmer
	class:responsive={heightSm !== null}
	class:tone-accent={tone === 'accent'}
	class:tone-surface={tone === 'surface'}
	style="--sk-h:{height};--sk-w:{width};--sk-r:{radius};--sk-h-sm:{heightSm || height};"
	aria-hidden="true"
></div>

<style>
	.skeleton-block {
		height: var(--sk-h);
		width: var(--sk-w);
		border-radius: var(--sk-r);
	}
	.skeleton-block.shimmer {
		background: linear-gradient(90deg, #ececec 25%, #f5f5f5 37%, #ececec 63%);
		background-size: 400% 100%;
		animation: sk-shimmer 1.4s ease-in-out infinite;
	}
	.skeleton-block.tone-accent {
		background: linear-gradient(90deg, #d9e2f5 25%, #eaf0fb 37%, #d9e2f5 63%);
		background-size: 400% 100%;
	}
	.skeleton-block.tone-surface {
		background: #ffffff;
		border: 0.1rem solid #e6e6e6;
		box-shadow: 0 0.2rem 0.6rem rgba(25, 90, 255, 0.04);
	}
	@media (min-width: 640px) {
		.skeleton-block.responsive {
			height: var(--sk-h-sm);
		}
	}
	@keyframes sk-shimmer {
		0% {
			background-position: 100% 0;
		}
		100% {
			background-position: 0 0;
		}
	}
	@media (prefers-reduced-motion: reduce) {
		.skeleton-block.shimmer {
			animation: none;
			background: #ececec;
		}
		.skeleton-block.tone-accent {
			background: #d9e2f5;
		}
	}
</style>
